<template>
  <g-master name="historico_vacaciones"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :modalFieldsSetup="master.modalFieldsSetup"
            :parentData="parentData"
            @action="masterAction"
            :beforeSend="master.beforeSend"
            ref="masterComponent"
            modalWidth="90%"
  >
    <template slot="expandedRowRender" slot-scope="{text}">
      <template v-for="ve in master.valoresExpandidos">
        {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
      </template>
    </template>
    <template slot="masterModal" slot-scope="{record}">
      <a-row :gutter="[16,16]">
        <a-col v-bind="colOptions" v-if="validarFechaIniDisfrute">
          <a-form-item :label="$t('Fecha inicio disfrute')" v-bind="fiOptions">
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD HH:mm:ss"
                           v-decorator="['htv_since', { rules: [{ required: true, validator: validateDateAble, message: messageForDateAble }] }]"></a-date-picker>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions" v-else>
          <a-form-item :label="$t('Fecha inicio disfrute')" v-bind="fiOptions">
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD HH:mm:ss"
                           v-decorator="['htv_since', { rules: [{ required: true, message: 'Valor requerido' }] }]"></a-date-picker>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Días disfrutados')">
            <a-input-number v-bind="fiOptions" style="width: 100%"
                            v-decorator="['htv_time', { rules: [
                              { required: true, validator: validateDays, message: messageForDays }
                              ] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Fecha fin disfrute')" v-bind="fiOptions">
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD HH:mm:ss"
                           v-decorator="['htv_to', { rules: [{ required: true, message: 'Valor requerido' }] }]"></a-date-picker>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Días compensados')">
            <a-input-number v-bind="fiOptions" style="width: 100%"
                            v-decorator="['htv_comp', { rules: [
                              { required: false, validator: validateDays, message: messageForDays }
                              ] }]"/>
            <br>
            <a-alert closable v-if="isVisibleDiasCompensados" message="Los días compensados no deben ser mayor a 7"
                     type="info" show-icon/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Fecha pago')" v-bind="fiOptions">
            <a-date-picker style="width: 100%"
                           type="date"
                           valueFormat="Y-MM-DD HH:mm:ss"
                           v-decorator="['payment_date', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Año')">
            <a-input
              readOnly
              v-decorator="['year', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Mes')">
            <a-input
              readOnly
              v-decorator="['month', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <g-dropdown :label="$t('Periodo')"
                      :formItemConfig="fiOptions"
                      endpoint="hierarchy_lookup"
                      :decorator="['period', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                      :params="period_request">
          </g-dropdown>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Días no hábil')">
            <a-input-number v-bind="fiOptions" style="width: 100%"
                            readOnly
                            v-decorator="['htv_nohab', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Días mes')">
            <a-input-number v-bind="fiOptions" style="width: 100%"
              readOnly
              v-decorator="['htv_daymonth', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Días sig mes')">
            <a-input-number v-bind="fiOptions" style="width: 100%"
                            readOnly
                            v-decorator="['htv_daynextmonth', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <g-dropdown endpoint="hierarchy_lookup"
                      :label="$t('Completo')"
                      :formItemConfig="fiOptions"
                      :decorator="['htv_completed', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                      :params="estado_sn">
          </g-dropdown>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Documento')">
            <a-input
              v-decorator="['htv_doc', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Comentario')">
            <a-textarea autoSize
                        v-decorator="['htv_obs', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
      </a-row>
    </template>
  </g-master>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'
  import JsUtils from '@/util/JsUtils'

  export default {
    props: ['empleadoseleccionado', 'id_t_hist_vac', 'htv_days_hist_vac', 'contract'],
    mounted () {
      this.httpClient = new HttpUtil()
    },
    data () {
      return {
        validarFechaIniDisfrute: this.$getConfigValue('VALIDAR_CAMPO_HISTVAC_FECHA_INI_DISFRUTE', 'SI') === 'SI',
        htv_comp: 0,
        htv_time: 0,
        isVisibleDiasCompensados: false,
        htv_since: null,
        month: null,
        year: null,
        messageForDateAble: '',
        calculoFechaHabil: {},
        messageForDays: null,
        estado_sn: {
          h_lookup_type: 'ESTADO_SN',
          use_code: true
        },
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        id_h_params: {
          h_lookup_type: 'TIPO_VACACION'
        },
        colOptions: {xs: 24, sm: 8},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          beforeSend: (data) => {
            data.id_emp = this.empleadoseleccionado
            return data
          },
          valoresExpandidos: [
            {label: 'Días No Hábil', column: 'htv_nohab'},
            {label: 'Días Mes', column: 'htv_daymonth'},
            {label: 'Días Sig Mes', column: 'htv_daynextmonth'},
            {label: 'Completo', column: 'htv_completed'},
            {label: 'Documento', column: 'htv_doc'},
            {label: 'Comentarios', column: 'htv_obs'},
            {label: 'Creado por', column: 'created_by'},
            {label: 'Modificado por', column: 'modified_by'}
          ],
          endpoint: 'dist_vac',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Fecha Inicio Disfrute', dataIndex: 'htv_since_desc', sorter: true},
              {title: 'Días disfrutados', dataIndex: 'htv_time', sorter: true, align: 'right'},
              {title: 'Fecha Fin Disfrute', dataIndex: 'htv_to_desc', sorter: true},
              {title: 'Dias compensados', dataIndex: 'htv_comp', sorter: true, align: 'right'},
              {title: 'Fecha de Pago', dataIndex: 'payment_date_desc', sorter: true},
              {title: 'Año', dataIndex: 'year', sorter: true, align: 'right'},
              {title: 'Mes Liq', dataIndex: 'mes', sorter: true},
              {title: 'Período Liq', dataIndex: 'period', sorter: true, align: 'right'},
              {title: 'Estado', dataIndex: 'htv_status'}
            ]
          },
          modalFieldsSetup: [
            {name: 'htv_comp'},
            {name: 'htv_completed'},
            {name: 'htv_daynextmonth'},
            {name: 'htv_days'},
            {name: 'htv_doc'},
            {name: 'htv_nohab'},
            {name: 'htv_daymonth'},
            {name: 'htv_obs'},
            {name: 'htv_since'},
            {name: 'htv_time'},
            {name: 'htv_to'},
            {name: 'payment_date'},
            {name: 'month'},
            {name: 'year'},
            {name: 'period'}
          ]
        }
      }
    },
    methods: {
      loadData () {
        this.$refs.masterComponent && this.$refs.masterComponent.$refs.datatable.loadData()
      },
      validateDays (rule, value, callback) {
        let suma = this.htv_time + this.htv_comp
        if (suma <= this.htv_days_hist_vac) {
          callback()
        } else {
          this.messageForDays = 'La sumatoria de dias disfrutados y compensados debe ser menor a los días del período'
          callback('La sumatoria de dias disfrutados y compensados debe ser menor a los días del período')
        }
      },
      async calcularFechaRegreso (record) {
        try {
          return await this.httpClient.getInstance().post('dist_vac/calcular_fecha_regreso', record)
        } catch (e) {
          console.log(e)
        }
      },
      async getDaysNoHabNextMonth (record) {
        try {
          return await this.httpClient.getInstance().post('dist_vac/days_no_hab_next_month', record)
        } catch (e) {
          console.log(e)
        }
      },
      async validateDateAble (rule, value, callback) {
        if (!JsUtils.isEmpty(value)) {
          this.calculoFechaHabil = await this.httpClient.getInstance().post('dist_vac/day_is_able', {
            'htv_since': value,
            'id_emp': this.empleadoseleccionado
          })
          if (this.calculoFechaHabil.data.diaHabil === '0') {
            this.messageForDateAble = 'La fecha seleccionada debe ser un día hábil'
            callback('La fecha seleccionada debe ser un día habil')
          } else if (this.calculoFechaHabil.data.diaHabil === '-1') {
            this.messageForDateAble = 'Por favor registrar en Hoja de Vida el campo Sistema de Vacaciones'
            callback('Por favor registrar en Hoja de Vida el campo Sistema de Vacaciones')
          } else {
            callback()
          }
        } else {
          callback()
        }
      },
      masterAction (action) {
        switch (action.action) {
          case 'masterCreate':
            this.isVisibleDiasCompensados = false
            this.htv_comp = 0
            this.htv_time = 0
            this.htv_since = null
            this.month = null
            this.year = null
            break
          case 'fieldsChange':
            if (Object.keys(action.changedFields).length > 1) {
              break
            }

            // htv_since htv_time

            if (!JsUtils.isEmpty(action.changedFields.payment_date)) {
              if (JsUtils.isEmpty(action.changedFields.payment_date.value)) {
                this.$refs.masterComponent.modal.form.setFieldsValue({
                  month: null,
                  year: null
                })
              } else {
                let endDate = new Date(action.changedFields.payment_date.value)
                let month = endDate.getMonth() + 1
                let year = endDate.getFullYear()
                this.$refs.masterComponent.modal.form.setFieldsValue({
                  month: month,
                  year: year
                })
                this.year = year
                this.month = month
              }
            }
            // htv_comp
            if (!JsUtils.isEmpty(action.changedFields.htv_comp)) {
              if (!JsUtils.isEmpty(action.changedFields.htv_comp.value)) {
                this.htv_comp = action.changedFields.htv_comp.value
                if (this.htv_comp > 7) {
                  this.isVisibleDiasCompensados = true
                } else {
                  this.isVisibleDiasCompensados = false
                }
              } else {
                this.isVisibleDiasCompensados = false
              }
            }

            // htv_time
            if (!JsUtils.isEmpty(action.changedFields.htv_time)) {
              if (!JsUtils.isEmpty(action.changedFields.htv_time.value)) {
                this.htv_time = action.changedFields.htv_time.value
                if (!JsUtils.isEmpty(this.htv_since)) {
                  let record = {
                    htv_since: this.htv_since,
                    htv_time: this.htv_time,
                    id_emp: this.empleadoseleccionado
                  }

                  this.calcularFechaRegreso(record)
                    .then((response) => {
                      this.$refs.masterComponent.modal.form.setFieldsValue({
                        htv_to: response.data.return
                      })
                    })
                    .catch(() => {
                    })
                    .then(() => {
                      this.modalLoading = false
                    })
                }
              }
            }
            // htv_since
            if (!JsUtils.isEmpty(action.changedFields.htv_since)) {
              if (!JsUtils.isEmpty(action.changedFields.htv_since.value)) {
                this.htv_since = action.changedFields.htv_since.value
                if (!JsUtils.isEmpty(this.htv_time)) {
                  let record = {
                    htv_since: this.htv_since,
                    htv_time: this.htv_time,
                    id_emp: this.empleadoseleccionado
                  }

                  this.calcularFechaRegreso(record)
                    .then((response) => {
                      this.$refs.masterComponent.modal.form.setFieldsValue({
                        htv_to: response.data.return
                      })
                    })
                    .catch(() => {
                    })
                    .then(() => {
                      this.modalLoading = false
                    })
                }
              }
            }
            if (!JsUtils.isEmpty(action.changedFields.htv_since) ||
              !JsUtils.isEmpty(action.changedFields.htv_time) ||
              !JsUtils.isEmpty(action.changedFields.payment_date) ||
              !JsUtils.isEmpty(action.changedFields.htv_to)
            ) {
              if (!JsUtils.isEmpty(this.htv_since) && !JsUtils.isEmpty(this.htv_time) &&
                !JsUtils.isEmpty(this.month) && !JsUtils.isEmpty(this.year)) {
                let record = {
                  'htv_since': this.htv_since,
                  'htv_time': this.htv_time,
                  'id_emp': this.empleadoseleccionado,
                  'month': this.month,
                  'year': this.year
                }
                if (this.htv_time === 0) {
                  this.$refs.masterComponent.modal.form.setFieldsValue({
                    htv_daymonth: 0,
                    htv_daynextmonth: 0
                  })
                } else {
                  this.getDaysNoHabNextMonth(record).then(resp => {
                    resp = resp.data
                    this.$refs.masterComponent.modal.form.setFieldsValue({
                      htv_nohab: resp.htv_nohab,
                      htv_daymonth: resp.htv_daynextmonth,
                      htv_daynextmonth: resp.htv_daymonth
                    })
                  })
                }
              }
            }
            break
          case 'masterEdit':
            this.isVisibleDiasCompensados = false
            break
        }
      }
    },
    computed: {
      parentData () {
        return {
          id_t_hist_vac: this.id_t_hist_vac
        }
      }
    },
    watch: {
      contract () {
        if (!this.contract) {
          if (this.master.actions.length > 0) {
            this.master.actions.splice(0)
          }
        } else {
          if (this.master.actions.length === 0) {
            this.master.actions.push({
              name: 'masterCreate',
              text: 'Crear',
              permisos: [],
              props: {icon: 'plus', type: 'button'},
              fnVisible: () => !this.$userIsInrol('Query')
            })
          }
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/HistoricoVacaciones.vue